import { useAuthContext } from "@isyc-react/auth/modules/context";
import React from "react";
import { useBuCode } from "./bucode-hook";
export const useBuVariables = () => {
    var _a;
    const { user } = useAuthContext();
    const buCode = useBuCode();
    const buVariables = React.useMemo(() => {
        var _a, _b;
        if ((_a = user === null || user === void 0 ? void 0 : user.businessUnit) === null || _a === void 0 ? void 0 : _a.id) {
            return {
                businessUnitId: (_b = user === null || user === void 0 ? void 0 : user.businessUnit) === null || _b === void 0 ? void 0 : _b.id
            };
        }
        else if (buCode) {
            return {
                businessUnitCode: buCode
            };
        }
        return {};
    }, [(_a = user === null || user === void 0 ? void 0 : user.businessUnit) === null || _a === void 0 ? void 0 : _a.id, buCode]);
    return buVariables;
};
